import useKeyBinding from "../hooks/useKeyBinding"
import type { Thread } from "../types"

export interface SuperShortcutsProps {
	threads: Thread[]
	onMessageSend: () => void
	onToggleUpdates: () => void
	onChangeOpenThread: (nextThread: number) => void
	currentOpenThread: number
}

export default function SuperShortcuts(props: SuperShortcutsProps) {
	useKeyBinding("shift+u", () => {
		props.onToggleUpdates()
	})

	// type cmd right to send a comment
	useKeyBinding("shift+right", () => {
		let nextThread = props.currentOpenThread + 1

		if (nextThread === props.threads.length) {
			nextThread = 0
		}

		props.onChangeOpenThread(nextThread)

		if (
			props.threads[nextThread] !== undefined &&
			props.threads[nextThread].y !== undefined
		) {
			window.scrollTo(0, props.threads[nextThread].y - 100)
		}
	})

	// type cmd left to send a comment
	useKeyBinding("shift+left", () => {
		let prevThread = props.currentOpenThread - 1

		if (prevThread < 0) {
			prevThread = props.threads.length - 1
		}

		props.onChangeOpenThread(prevThread)

		if (
			props.threads[prevThread] !== undefined &&
			props.threads[prevThread].y !== undefined
		) {
			window.scrollTo(0, props.threads[prevThread].y - 100)
		}
	})

	// type cmd enter to send a comment
	useKeyBinding("command+enter", () => {
		props.onMessageSend()
	})

	return null
}
